<template>
  <HomeSectionWrapper
    :title="$t('recently_added.title')"
    :description="$t('recently_added.description')"
    bg="bg-white"
  >
    <div>
      <div
        v-if="status === 'pending' || status === 'idle'"
        class="columns-1 sm:columns-2 lg:columns-3 xl:columns-4 gap-1 space-y-1"
      >
        <div v-for="n in limit" :key="n" class="break-inside-avoid">
          <div
            class="w-full bg-gray-200 animate-pulse"
            :style="{
              height: ['250px', '400px', '320px', '500px'][n % 4],
            }"
          >
            <div
              class="flex items-center justify-center h-full opacity-10"
            ></div>
          </div>
        </div>
      </div>
      <div v-else class="columns-2 lg:columns-3 xl:columns-4 gap-1">
        <div
          v-for="art in feturedArtworks"
          :key="art._id"
          class="break-inside-avoid group"
        >
          <div
            class="group relative overflow-hidden bg-white shadow-sm transition-transform duration-500 hover:scale-[1.02] hover:shadow-lg"
          >
            <div
              class="absolute opacity-0 z-20 group-hover:opacity-100 transition-all duration-300 bottom-0 left-0 w-full text-sm p-2.5 bg-white/50"
            >
              <p>
                {{ cutName(art.title[locale as Locale], 20) }}
              </p>
            </div>
            <NuxtLink :to="$localePath(`/artwork-details/${art._id}`)">
              <BaseImage
                @contextmenu.prevent
                @dragstart.prevent
                :alt="art.title[locale as Locale] || 'Medium.am Artwork'"
                :uri="art.thumbnail"
                img-class="h-auto w-full block"
                loader-class="min-h-60 w-full"
              />
            </NuxtLink>
          </div>
        </div>
      </div>

      <div
        v-if="feturedArtworks.length > 0"
        class="flex justify-center xl:mt-14 lg:mt-10 mt-5"
      >
        <NuxtLink
          :to="$localePath('/gallery')"
          class="flex items-center justify-center w-fit px-5 rounded-lg py-2.5 text-white bg-primary transition-all hover:-translate-y-1 hover:shadow"
        >
          {{ $t("recently_added.view_full_collection") }}
          <Icon name="ph:arrow-right" class="ml-2.5" size="22" />
        </NuxtLink>
      </div>
    </div>
  </HomeSectionWrapper>
</template>

<script setup lang="ts">
import type { Locale } from "~~/types/global";
import { ref } from "vue";
import { useI18n } from "vue-i18n";
import type { Artwork } from "~~/types/artwork";
import { cutName } from "../../utils/helpers";

const { locale } = useI18n();
const limit = ref<number>(12);

const { data, status } = await useFetch<any>("/api/artwork/artworks", {
  query: {
    limit: limit.value,
  },
  server: true,
});
const feturedArtworks = computed<Artwork[]>(() => data.value?.data || []);
</script>

<style scoped>
.break-inside-avoid {
  break-inside: avoid;
  display: inline-block;
  width: 100%;
}
img {
  image-orientation: from-image;
}
</style>
